import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.pageYOffset > 100);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // Close mobile menu and scroll to top when route changes
    useEffect(() => {
        setMobileMenuOpen(false);
        window.scrollTo(0, 0);
    }, [location]);

    const navbarStyle = {
        background: scrolled ? 'rgba(10, 10, 10, 0.98)' : 'rgba(10, 10, 10, 0.95)',
        boxShadow: scrolled ? '0 4px 16px rgba(0, 0, 0, 0.3)' : '0 4px 24px rgba(0, 0, 0, 0.1)'
    };

    return (
        <nav className="navbar" style={navbarStyle}>
            <div className="nav-container">
                <Link to="/" className="logo">
                    <img src="/favicon.png" alt="Deccan Arts Logo" style={{ height: '2.5rem', marginRight: '1.5rem', marginLeft: '1rem', transform: 'scale(1.8)', filter: 'brightness(0) invert(1)' }} />
                    DECCAN ARTS
                </Link>
                <button
                    className="menu-toggle"
                    aria-label="Toggle menu"
                    onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                >
                    <span></span>
                    <span></span>
                    <span></span>
                </button>
                <ul className={`nav-menu ${mobileMenuOpen ? 'active' : ''}`}>
                    <li><Link to="/" className="nav-link">Home</Link></li>
                    <li><Link to="/about" className="nav-link">About</Link></li>
                    <li><Link to="/courses" className="nav-link">Courses</Link></li>
                    <li><Link to="/pricing" className="nav-link">Pricing</Link></li>
                    <li><Link to="/events" className="nav-link">Events</Link></li>
                    <li><Link to="/schedule" className="nav-link">Schedule</Link></li>
                    <li><Link to="/testimonials" className="nav-link">Testimonials</Link></li>
                    <li><Link to="/contact" className="nav-link">Contact</Link></li>
                    <li>
                        <Link to="/registration" className="nav-link btn-primary" style={{ padding: '0.7rem 1.5rem' }}>
                            Join Now
                        </Link>
                    </li>
                </ul>
            </div>
        </nav>
    );
};

export default Navbar;
